// Source: https://docs.google.com/spreadsheets/d/16W9uJFLP5pBg-8xPM-VRAwG_BdGjrxeA
import { country_enum, crrem_type_of_use_enum } from '@predium/enums';
import { TargetPath } from './TargetPathTypes';

//
//ATTENTION: ALL of these paths have to match TARGET_PATH_YEARS_RANGE.length !!
// Columns AZB to BAH
//
export const CrremCo2TargetPath: TargetPath = {
  [country_enum.DE]: {
    [crrem_type_of_use_enum.MFH]: [
      33.42507176, 31.24771073, 28.77232834, 26.38860401, 24.05612869, 21.96047276, 19.81525533, 17.83396452,
      15.98649421, 14.24603127, 12.54782966, 11.11557881, 9.718440362, 8.412229153, 7.189508732, 6.050346118,
      4.959165669, 3.969067528, 3.12672323, 2.451522861, 1.909485126, 1.609601942, 1.382703894, 1.18376801, 1.010933721,
      0.8497844602, 0.7336258017, 0.6226235849, 0.5245909198, 0.4346517927, 0.3489624909,
    ],
    [crrem_type_of_use_enum.OFFICE]: [
      55.26532331, 51.6865314, 47.85979313, 44.14787616, 40.27128332, 36.96641857, 33.55085846, 30.26740148, 27.2898626,
      24.46663213, 21.6426881, 19.29326117, 16.9682583, 14.79624393, 12.74984964, 10.83101135, 8.891809615, 7.200719395,
      5.754778536, 4.591143709, 3.652082851, 3.136969309, 2.746292295, 2.402387522, 2.102530559, 1.822482106,
      1.619311076, 1.425192671, 1.253397022, 1.095408091, 0.9442307829,
    ],
    [crrem_type_of_use_enum.RETAIL]: [
      72.69937739, 68.08608949, 63.02076058, 58.10684601, 53.07102153, 48.69593729, 44.17328102, 39.87493578,
      35.93249151, 32.19418636, 28.47609889, 25.36543508, 22.29399711, 19.41775105, 16.70778378, 14.16668121,
      11.6368469, 9.397582365, 7.482832391, 5.94177956, 4.698406401, 4.015410802, 3.497546733, 3.041615145, 2.643998472,
      2.272251099, 2.002934472, 1.745210746, 1.516966344, 1.306899468, 1.105810932,
    ],
    [crrem_type_of_use_enum.SHOPPING_CENTER]: [
      74.76747112, 70.02547811, 64.806052, 59.74259288, 54.56254452, 50.05431069, 45.39391689, 40.96930601, 36.90681463,
      33.05466198, 29.22533114, 26.0199593, 22.85565484, 19.89179296, 17.09926836, 14.4807478, 11.87743093, 9.569966191,
      7.596890108, 6.008881441, 4.72764777, 4.023765404, 3.490077567, 3.020208349, 2.610429064, 2.227273121, 1.9497271,
      1.684090023, 1.448822643, 1.232276575, 1.024978416,
    ],
    [crrem_type_of_use_enum.RETAIL_WAREHOUSE]: [
      48.48301194, 45.30625069, 41.96085929, 38.71606823, 35.28998139, 32.40103034, 29.4157151, 26.52666872,
      23.92411587, 21.45650599, 18.98004815, 16.92645665, 14.89153686, 12.99320431, 11.20469083, 9.527679793,
      7.818012439, 6.339956278, 5.076206203, 4.05924532, 3.238447727, 2.788577294, 2.447328306, 2.146959916,
      1.885094787, 1.640682796, 1.463217576, 1.293817768, 1.143959496, 1.006209339, 0.8744287651,
    ],
    [crrem_type_of_use_enum.HOTEL]: [
      61.62437728, 57.6685987, 53.39049844, 49.24055456, 44.9415194, 41.24664977, 37.42764633, 33.77434804, 30.4451824,
      27.28848427, 24.13870024, 21.51186657, 18.91485096, 16.48620344, 14.19799268, 12.05239146, 9.897953884,
      8.007100285, 6.39031798, 5.089146072, 4.039189005, 3.462896591, 3.025870605, 2.641141491, 2.305659346,
      1.992194358, 1.764918828, 1.54762164, 1.355255173, 1.178288217, 1.008922469,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_COLD]: [
      41.60108386, 38.54183512, 35.43678838, 32.46091153, 29.32684978, 26.72875969, 24.08821742, 21.53520248,
      19.27642241, 17.15747724, 15.0472738, 13.31417759, 11.6146307, 10.04953405, 8.590819201, 7.237676913, 5.849903279,
      4.683256879, 3.694456325, 2.904601758, 2.27161852, 1.923692873, 1.660285316, 1.430261831, 1.231270583,
      1.047741573, 0.9142877356, 0.7886045365, 0.6784782888, 0.5783855677, 0.4837688493,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_WARM]: [
      16.71301303, 15.419405, 14.32869215, 13.27196721, 11.95609714, 11.01532886, 10.04532513, 9.003738853, 8.157659383,
      7.355813166, 6.507016615, 5.839148884, 5.163008293, 4.546629647, 3.966056632, 3.42178946, 2.787284911,
      2.307102335, 1.89675275, 1.566827805, 1.299987589, 1.155722626, 1.045999629, 0.9495601644, 0.8656527187,
      0.7881656042, 0.7311090596, 0.6774937182, 0.6303923925, 0.587442747, 0.5465184836,
    ],
    [crrem_type_of_use_enum.HEALTH_FACILITY]: [
      62.48609284, 58.48593544, 54.15470091, 49.95319257, 45.60442757, 41.86364662, 37.9971499, 34.30031395,
      30.92975485, 27.73380096, 24.54565911, 21.88616915, 19.25713224, 16.79827391, 14.48159655, 12.30930083,
      10.12952573, 8.215156016, 6.578262283, 5.260899531, 4.197887779, 3.614393397, 3.171911217, 2.782376269,
      2.442700332, 2.125301555, 1.895188447, 1.675162656, 1.480374596, 1.301173549, 1.129666661,
    ],
    [crrem_type_of_use_enum.LODGING_LEISURE_RECREATION]: [
      61.9113913021828, 57.9407018339805, 53.6447489432817, 49.4774798668566, 45.1617359333676, 41.4514405139971,
      37.6164797605948, 33.9485532108779, 30.6054797384897, 27.4355920256039, 24.2729201177717, 21.6351142300117,
      19.0273397501337, 16.5885416730413, 14.290766390119, 12.1361960557557, 9.97324530332168, 8.07449050188688,
      6.45095093887554, 5.1443390530418, 4.08999573002881, 3.51128351951964, 3.0724243017454, 2.68608047066821,
      2.34918924948419, 2.03440254413736, 1.80617361338609, 1.58795963922362, 1.39477953939197, 1.21706194861469,
      1.04697679687475,
    ],
  },
  [country_enum.AT]: {
    [crrem_type_of_use_enum.MFH]: [
      20.77988167, 19.40271476, 17.94441374, 16.53500715, 15.07050886, 13.8240927, 12.53534968, 11.30391269,
      10.18571615, 9.127023996, 8.070435439, 7.194510497, 6.328313242, 5.519677346, 4.759369783, 4.047873309,
      3.339430959, 2.715878783, 2.183504416, 1.755483279, 1.411151064, 1.220447769, 1.076271739, 0.9494212348,
      0.8388270775, 0.7350572045, 0.660458876, 0.5886492662, 0.5249715873, 0.4662907588, 0.4101477894,
    ],
    [crrem_type_of_use_enum.OFFICE]: [
      45.26201443, 40.38361325, 37.78363447, 35.28685431, 30.82509417, 28.62852207, 26.36375882, 23.24737903,
      21.28665915, 19.43457568, 17.17003258, 15.64310062, 13.99419474, 12.59037061, 11.27427631, 10.04662351,
      8.091996508, 7.01706675, 6.103801206, 5.374778113, 4.793397332, 4.481219888, 4.250785254, 4.050895782, 3.87952589,
      3.720193298, 3.611858995, 3.508903814, 3.421197009, 3.344230482, 3.275153151,
    ],
    [crrem_type_of_use_enum.RETAIL]: [
      54.55837737, 49.11236607, 45.84172158, 42.69759035, 37.61406525, 34.84578203, 31.99090351, 28.33542308,
      25.86357349, 23.52813702, 20.79191541, 18.86581546, 16.8260013, 15.05459363, 13.39330615, 11.84301696, 9.58337101,
      8.226274056, 7.072368072, 6.150081061, 5.413402267, 5.015298828, 4.71998225, 4.463082675, 4.242077752,
      4.036235256, 3.89453615, 3.759505522, 3.643404122, 3.540312694, 3.446275297,
    ],
    [crrem_type_of_use_enum.SHOPPING_CENTER]: [
      46.86058306, 41.88806667, 39.17688509, 36.5727679, 32.00791317, 29.71654587, 27.35393585, 24.148168, 22.10269791,
      20.17046987, 17.82771795, 16.2346001, 14.52087788, 13.05610487, 11.68277423, 10.40162522, 8.396423146,
      7.274707359, 6.32154132, 5.560473214, 4.953342532, 4.626917734, 4.385725051, 4.176382757, 3.9967829, 3.82973852,
      3.715872012, 3.607598414, 3.515183512, 3.433885226, 3.360669277,
    ],
    [crrem_type_of_use_enum.RETAIL_WAREHOUSE]: [
      40.19349261, 35.62576642, 33.39286896, 31.25040912, 27.12896502, 25.24531255, 23.30354226, 20.48223311,
      18.80127433, 17.21374867, 15.20737349, 13.89892163, 12.46397499, 11.26134356, 10.13418686, 9.083125452,
      7.295447137, 6.374958413, 5.593404701, 4.970162436, 4.473782272, 4.208635453, 4.01371322, 3.845027585,
      3.700824868, 3.566948948, 3.476876494, 3.391477447, 3.319312103, 3.256644747, 3.201229026,
    ],
    [crrem_type_of_use_enum.HOTEL]: [
      47.46312037, 42.45206713, 39.69535193, 37.04728404, 32.44021572, 30.11003315, 27.70735834, 24.46498924,
      22.38481694, 20.41977254, 18.04499687, 16.42477825, 14.68451603, 13.19478661, 11.79801971, 10.4949659, 8.46905513,
      7.32818212, 6.358678241, 5.584488838, 4.966814483, 4.634555897, 4.388958174, 4.175745284, 3.992775549,
      3.822573464, 3.706441715, 3.595990413, 3.501647712, 3.418575725, 3.343665157,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_COLD]: [
      36.54477243, 32.17826977, 30.18313008, 28.27016274, 24.36914061, 22.68816551, 20.95559705, 18.32540453,
      16.82564639, 15.40947427, 13.57031388, 12.40337112, 11.10700541, 10.03468606, 9.029903836, 8.093220289,
      6.413674276, 5.593216676, 4.896972434, 4.342244181, 3.900918733, 3.666233549, 3.494312621, 3.345837644,
      3.219231047, 3.101843359, 3.023599064, 2.949571089, 2.887471914, 2.834066101, 2.787498976,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_WARM]: [
      19.71240662, 16.39704792, 15.64389846, 14.9297455, 12.18015543, 11.55791884, 10.91817114, 9.286326541,
      8.733117614, 8.21205567, 7.246385742, 6.818652894, 6.24620112, 5.854601168, 5.489074168, 5.149873442, 4.035184928,
      3.737266192, 3.486658381, 3.289831081, 3.136098409, 3.060537577, 3.008770011, 2.965870716, 2.931182078, 2.899925,
      2.883468207, 2.868840007, 2.85932412, 2.854298404, 2.853954244,
    ],
    [crrem_type_of_use_enum.HEALTH_FACILITY]: [
      57.49741475, 51.87016035, 48.38536617, 45.03452981, 39.75246948, 36.80163367, 33.75832594, 29.93070574,
      27.29564776, 24.80587225, 21.91903938, 19.86548143, 17.70084669, 15.81206624, 14.04055541, 12.38724547,
      10.03020418, 8.583008658, 7.352263979, 6.368266031, 5.581999161, 5.156458765, 4.840424789, 4.565321367,
      4.328467524, 4.10777399, 3.955421198, 3.810148585, 3.684980532, 3.573547183, 3.471539809,
    ],
    [crrem_type_of_use_enum.LODGING_LEISURE_RECREATION]: [
      58.8671121087017, 53.149212274688, 49.5573150247235, 46.1030988665464, 40.7217447477104, 37.6796085893618,
      34.5420614231783, 30.6283486569463, 27.9116649780577, 25.3446996057934, 22.3825412568292, 20.2652375190876,
      18.0381760335114, 16.0906937207631, 14.2640566996347, 12.5592228076513, 10.1534710077361, 8.66121432964003,
      7.39204017862656, 6.37717862975094, 5.56611118640634, 5.12684869625688, 4.80045329102727, 4.51624554655042,
      4.27146515560733, 4.04334414494575, 3.88566310546177, 3.735268151063, 3.60556557659136, 3.48996016870443,
      3.38396675560758,
    ],
  },
  [country_enum.PL]: {
    [crrem_type_of_use_enum.MFH]: [
      66.60604006, 62.68570628, 58.01681988, 53.46872627, 49.0268316, 44.9517477, 40.70748852, 36.79239652, 33.07756675,
      29.54764018, 26.07894337, 23.14259554, 20.25327594, 17.53029714, 14.96607275, 12.56346695, 10.27436082,
      8.16407154, 6.361405125, 4.911530157, 3.744799841, 3.098354421, 2.609443768, 2.179202629, 1.804047099,
      1.452057705, 1.198892419, 0.9552113895, 0.7390785099, 0.5398431538, 0.3491296238,
    ],
    [crrem_type_of_use_enum.OFFICE]: [
      157.2009649, 145.1766659, 133.8814565, 123.0106542, 110.756599, 101.1981607, 91.40806034, 81.55454664,
      73.14374289, 65.23870228, 57.17769947, 50.71909093, 44.31534275, 38.47345312, 33.03758173, 28.00593285,
      22.58419253, 18.27130458, 14.62714728, 11.72555945, 9.415661138, 8.139623248, 7.183136426, 6.352189639,
      5.637347472, 4.97678327, 4.509232741, 4.067114199, 3.683425435, 3.338727522, 3.018728246,
    ],
    [crrem_type_of_use_enum.RETAIL]: [
      193.3923509, 179.0227773, 164.9833946, 151.469042, 136.6824263, 124.7983185, 112.625693, 100.6018329, 90.14404129,
      80.31459285, 70.39075508, 62.35920853, 54.42933218, 47.16408535, 40.40321735, 34.14448428, 27.57445265,
      22.21000263, 17.67648763, 14.06569469, 11.19013874, 9.599378338, 8.405706895, 7.368035504, 6.474651752,
      5.648709647, 5.062587088, 4.507925513, 4.025581077, 3.591157502, 3.18654415,
    ],
    [crrem_type_of_use_enum.SHOPPING_CENTER]: [
      185.6771197, 171.8043721, 158.3463186, 145.391979, 131.1418642, 119.7504292, 108.0825209, 96.51842968,
      86.49427464, 77.07249521, 67.54328279, 59.84494943, 52.23837003, 45.27464901, 38.79446998, 32.795684, 26.46890787,
      21.3272221, 16.98210978, 13.52155575, 10.76582944, 9.241740258, 8.098314308, 7.104435722, 6.248874448,
      5.457966209, 4.8969621, 4.366141785, 3.904696693, 3.489280717, 3.102592119,
    ],
    [crrem_type_of_use_enum.RETAIL_WAREHOUSE]: [
      150.444869, 138.8556984, 128.0696266, 117.689293, 105.9051141, 96.77816677, 87.43010604, 77.97926558, 69.94824784,
      62.40025047, 54.68486704, 48.51809212, 42.39749273, 36.81968436, 31.62964501, 26.82566206, 21.61696892,
      17.49918157, 14.02003044, 11.25002433, 9.045074792, 7.827428655, 6.914947664, 6.122355336, 5.440638719,
      4.810757755, 4.365206379, 3.943968406, 3.578583631, 3.250532886, 2.946232405,
    ],
    [crrem_type_of_use_enum.HOTEL]: [
      179.8928548, 166.3955997, 153.3769048, 140.8458135, 127.0011767, 115.9820953, 104.6956436, 93.47903785,
      83.78261782, 74.6689476, 65.43798621, 57.99148965, 50.6292525, 43.8934195, 37.62538036, 31.8230579, 25.68013009,
      20.70680571, 16.50408487, 13.15707883, 10.4919177, 9.018217474, 7.912766202, 6.951985463, 6.125009766,
      5.360579519, 4.818559503, 4.305758001, 3.860108273, 3.459057913, 3.085916535,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_COLD]: [
      119.3929522, 110.3714604, 102.4036371, 94.67204209, 85.36284039, 78.46858805, 71.31667034, 63.82597548,
      57.59218148, 51.68462581, 45.49938182, 40.60648039, 35.67229563, 31.16100112, 26.92527181, 22.96859948,
      18.51577895, 15.05690972, 12.11160587, 9.751089865, 7.859199809, 6.819160339, 6.038194062, 5.354795164,
      4.762669091, 4.209867308, 3.818448391, 3.444141435, 3.11656306, 2.81938729, 2.54049601,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_WARM]: [
      50.70307695, 45.58531324, 42.37134444, 39.28546128, 34.48947418, 31.77983667, 29.00596942, 25.54384967,
      23.16116437, 20.92325978, 18.34806872, 16.52156235, 14.6120673, 12.96178332, 11.42785828, 10.00981605,
      7.969647443, 6.753475865, 5.728363734, 4.915294662, 4.271186073, 3.921965909, 3.663957594, 3.44178844,
      3.252728508, 3.079181172, 2.960810175, 2.850116535, 2.756956161, 2.676488899, 2.6056673,
    ],
    [crrem_type_of_use_enum.HEALTH_FACILITY]: [
      189.5343945, 175.417602, 161.6739948, 148.4445723, 133.9309239, 122.2974839, 110.3816545, 98.59172103, 88.3545602,
      78.73253043, 69.00947483, 61.14746444, 53.38207895, 46.270246, 39.65219026, 33.52571616, 27.07945094, 21.82834157,
      17.39068432, 13.85633171, 11.04174411, 9.484905481, 8.316798536, 7.301408568, 6.427268585, 5.619151426,
      5.04580893, 4.503277594, 4.031566574, 3.606813911, 3.211320528,
    ],
    [crrem_type_of_use_enum.LODGING_LEISURE_RECREATION]: [
      169.951693341327, 157.104219641989, 144.845824875197, 133.047155179023, 119.90418923508, 109.529457462238,
      98.9031077185298, 88.287817834876, 79.1585359067223, 70.5780418126534, 61.8631971675497, 54.8524985585024,
      47.9130902316244, 41.5716123315738, 35.6706765461775, 30.2083298271121, 24.383547415752, 19.7015686490949,
      15.7452531136543, 12.5947393280854, 10.0862992045868, 8.69979594812262, 7.66005900901457, 6.75655335407624,
      5.97904435925253, 5.26043368785969, 4.75126521897688, 4.2696448716002, 3.85132866706477, 3.47513768422038,
      3.12543946862762,
    ],
  },
  // TODO: Add correct values BLU-2824
  [country_enum.FR]: {
    [crrem_type_of_use_enum.MFH]: [
      18.98278827, 17.58474901, 16.22053149, 14.90690494, 13.46942415, 12.31854964, 11.14202498, 9.9819035, 8.97476678,
      8.02870752, 7.07357826, 6.30056962, 5.5360897, 4.83370698, 4.17802833, 3.56877666, 2.93134338, 2.40493139,
      1.95809608, 1.60061158, 1.31448468, 1.15554297, 1.03559286, 0.93064009, 0.83962952, 0.75484937, 0.69393761,
      0.6357079, 0.58429543, 0.53711447, 0.49214538,
    ],
    [crrem_type_of_use_enum.OFFICE]: [
      28.05803247, 25.31381054, 23.53489134, 21.82113776, 19.22670207, 17.72734651, 16.19728017, 14.32970192,
      13.02361973, 11.79891965, 10.40824647, 9.41068049, 8.37307805, 7.46951597, 6.62745836, 5.84634049, 4.75962373,
      4.08526637, 3.51404502, 3.05837413, 2.69497717, 2.49546747, 2.34642118, 2.21703464, 2.10597485, 2.00334828,
      1.93170497, 1.86375872, 1.80457613, 1.75047099, 1.6983055,
    ],
    [crrem_type_of_use_enum.RETAIL]: [
      45.86656607, 41.96641786, 38.83423567, 35.81791323, 31.9783594, 29.33870815, 26.64410713, 23.7185373, 21.41678207,
      19.25746145, 16.96251594, 15.20223233, 13.42385723, 11.82848774, 10.34116217, 8.96097098, 7.31189177, 6.12081337,
      5.11127926, 4.30513444, 3.66137272, 3.30602709, 3.03936801, 2.80711951, 2.60690135, 2.42128943, 2.2900201,
      2.16515809, 2.05581332, 1.95580235, 1.86005197,
    ],
    [crrem_type_of_use_enum.SHOPPING_CENTER]: [
      24.95216041, 22.41667867, 20.88213522, 19.40360292, 17.03401391, 15.74057592, 14.42080429, 12.74428091,
      11.61799995, 10.56207609, 9.33469877, 8.47486632, 7.57103454, 6.79240084, 6.0668674, 5.39393175, 4.40876787,
      3.82772134, 3.33565165, 2.94327026, 2.6305023, 2.45913385, 2.33132639, 2.22051492, 2.12555559, 2.03791474,
      1.97703884, 1.91937059, 1.86924641, 1.82343107, 1.77913625,
    ],
    [crrem_type_of_use_enum.RETAIL_WAREHOUSE]: [
      21.865091901, 19.521952267, 18.212587057, 16.950797677, 14.788391994, 13.684695225, 12.558698106, 11.058220842,
      10.097616409, 9.197210151, 8.12030059, 7.387381701, 6.606811906, 5.943292553, 5.325129458, 4.751877512,
      3.860288783, 3.365222838, 2.94608686, 2.612023119, 2.345906873, 2.200468981, 2.092231875, 1.998536282,
      1.918412592, 1.844580211, 1.793625881, 1.745428211, 1.703650846, 1.665474076, 1.628431625,
    ],
    [crrem_type_of_use_enum.HOTEL]: [
      26.90460258, 24.24017624, 22.55467511, 20.93084011, 18.42235708, 17.00171809, 15.55204159, 13.75749833,
      12.52014916, 11.35996756, 10.03171786, 9.08680359, 8.10033796, 7.24453254, 6.4470189, 5.70725608, 4.65936018,
      4.02067296, 3.4797091, 3.04823204, 2.70418914, 2.51543705, 2.37450978, 2.25222397, 2.14731895, 2.050421,
      1.98289378, 1.91887652, 1.86315671, 1.81222053, 1.76306377,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_COLD]: [
      25.8058352577, 23.2287628701, 21.6286026162, 20.080855974, 17.6394976383, 16.2767774906, 14.8783124432,
      13.1268197742, 11.9255791647, 10.7951163094, 9.4907166263, 8.5644712711, 7.5919718079, 6.745890604, 5.9542724074,
      5.2169975718, 4.1684167922, 3.5264216181, 2.9808468949, 2.5445122137, 2.1956364864, 2.004808203, 1.86231174,
      1.7383135125, 1.6316502031, 1.5327005585, 1.4638284709, 1.3982134881, 1.3409184205, 1.2883353444, 1.2373695701,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_WARM]: [
      12.51353252, 10.76145135, 10.14404856, 9.54830024, 8.02255939, 7.50192872, 6.97139179, 6.01189616, 5.56040808,
      5.13790029, 4.52337127, 4.18045191, 3.77866056, 3.4688823, 3.18066334, 2.91373486, 2.30969829, 2.07884672,
      1.88383271, 1.72897641, 1.60621875, 1.54046427, 1.49236598, 1.45126667, 1.41673223, 1.38533266, 1.36486683,
      1.34577183, 1.32964383, 1.31494004, 1.3001838,
    ],
    [crrem_type_of_use_enum.HEALTH_FACILITY]: [
      45.691772864, 41.804638461, 38.687691766, 35.68603408, 31.860498212, 29.233684794, 26.552194504, 23.638535899,
      21.347990295, 19.19919195, 16.914427038, 15.16273036, 13.392695129, 11.805114244, 10.325053317, 8.951606701,
      7.30885876, 6.123597773, 5.118998345, 4.31679927, 3.676193998, 3.322602817, 3.057267866, 2.826177421, 2.62696303,
      2.442285391, 2.311687349, 2.187466117, 2.078686086, 1.979191939, 1.883932259,
    ],
    [crrem_type_of_use_enum.LODGING_LEISURE_RECREATION]: [
      60.464107498, 55.603911448, 51.347784588, 47.249621166, 42.375941725, 38.78922454, 35.127426041, 31.323147474,
      28.194441812, 25.258877549, 22.212893921, 19.819139632, 17.425520121, 15.255574027, 13.232324911, 11.354576882,
      9.238430822, 7.618192763, 6.244620563, 5.147391642, 4.27077462, 3.786000365, 3.421658672, 3.103978776,
      2.829710637, 2.575175722, 2.394384348, 2.222251288, 2.07124461, 1.933106815, 1.801157275,
    ],
  },
  // Source: CRREM Risk Assessment Tool Europe v2.07, "Targets" sheet (2°C scenario),
  // UK column — extracted from libs/lookup/backend-lookup/crrem-source/v07 workbook, DE-verified. See BLU-3092.
  [country_enum.UK]: {
    [crrem_type_of_use_enum.MFH]: [
      28.1828951, 26.1461164, 24.0747554, 22.0839699, 19.9889262, 18.2464908, 16.4650412, 14.7501028, 13.2240149,
      11.7900344, 10.3616626, 9.1899132, 8.0385659, 6.9757492, 5.9847043, 5.0650577, 4.1375738, 3.3458123, 2.6745933,
      2.1381137, 1.709129, 1.4702591, 1.2898489, 1.1321079, 0.9954045, 0.8682782, 0.7767656, 0.6895228, 0.6126713,
      0.5424264, 0.475866,
    ],
    [crrem_type_of_use_enum.OFFICE]: [
      52.5054785, 48.4608746, 45.1233603, 41.8631582, 37.7624449, 34.8398227, 31.7878642, 28.5286708, 25.8523101,
      23.3029417, 20.6082924, 18.4793962, 16.3183633, 14.3319348, 12.4550726, 10.6905649, 8.7210382, 7.1638962,
      5.8294856, 4.7526032, 3.8829406, 3.3980504, 3.0292047, 2.7031375, 2.417392, 2.1482838, 1.9525854, 1.7635903,
      1.5949179, 1.4386771, 1.2886735,
    ],
    [crrem_type_of_use_enum.RETAIL]: [
      61.4783019, 56.9281071, 52.9781574, 49.1197842, 44.4385943, 40.9783044, 37.3646441, 33.589187, 30.4197376,
      27.4007944, 24.244355, 21.7233971, 19.1756399, 16.8233812, 14.6009793, 12.5117394, 10.2335615, 8.3894776,
      6.8094098, 5.5346085, 4.5054357, 3.9323712, 3.4968521, 3.1120252, 2.7749785, 2.4576353, 2.227297, 2.0048865,
      1.8065491, 1.6229307, 1.4466879,
    ],
    [crrem_type_of_use_enum.SHOPPING_CENTER]: [
      52.7331736, 48.6800391, 45.3321913, 42.0618965, 37.951389, 35.0196949, 31.958259, 28.6903549, 26.0056745,
      23.448383, 20.7459421, 18.6104308, 16.4428728, 14.4502717, 12.5675794, 10.7975926, 8.8228581, 7.2608746,
      5.9223192, 4.8420973, 3.9697434, 3.4833654, 3.1133948, 2.7863361, 2.4997251, 2.229803, 2.0335201, 1.8439612,
      1.6747883, 1.5180856, 1.3676392,
    ],
    [crrem_type_of_use_enum.RETAIL_WAREHOUSE]: [
      40.9012212, 37.5182874, 34.9822711, 32.5048993, 29.1638593, 26.9448861, 24.6280303, 22.0444744, 20.0134222,
      18.078589, 15.9882875, 14.3724848, 12.7175605, 11.2098961, 9.7852441, 8.4457153, 6.8801222, 5.6985031, 4.6855855,
      3.8677209, 3.2068103, 2.8373142, 2.5557245, 2.3065564, 2.0879492, 1.8819663, 1.7316014, 1.5863373, 1.4564876,
      1.3360763, 1.2204118,
    ],
    [crrem_type_of_use_enum.HOTEL]: [
      60.5629071, 56.0597819, 52.166849, 48.3641645, 43.737016, 40.3267822, 36.7654154, 33.0380217, 29.914478,
      26.9392515, 23.8258039, 21.3413464, 18.8295926, 16.5113921, 14.3211594, 12.2621515, 10.0127086, 8.1953385,
      6.638141, 5.3817656, 4.3674429, 3.8025874, 3.3732754, 2.993919, 2.6616483, 2.3487957, 2.1216823, 1.9023828,
      1.7068072, 1.5257375, 1.3519376,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_COLD]: [
      34.2477143, 30.8999107, 28.5314391, 26.2628869, 23.1655724, 21.1987711, 19.1996894, 16.9324903, 15.2329806,
      13.641003, 11.9184314, 10.6247109, 9.3122423, 8.1478999, 7.06554, 6.0641746, 4.8361507, 3.9823525, 3.2595078,
      2.6815386, 2.218936, 1.9570787, 1.7574057, 1.5822846, 1.4298472, 1.2880809, 1.1837642, 1.0843764, 0.996166,
      0.9151772, 0.8383729,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_WARM]: [
      18.0394662, 15.9494211, 14.9795142, 14.0317756, 12.1751205, 11.3310619, 10.4505806, 9.1872055, 8.4170716,
      7.6830268, 6.7736075, 6.1603783, 5.4943788, 4.9222091, 4.3811656, 3.8720364, 3.0957208, 2.6478649, 2.2631377,
      1.951388, 1.6983744, 1.5543558, 1.4432622, 1.3443534, 1.2569329, 1.1742956, 1.1125113, 1.0526965, 0.9987056,
      0.9483041, 0.8997378,
    ],
    [crrem_type_of_use_enum.HEALTH_FACILITY]: [
      78.5694607, 73.0403065, 67.9045179, 62.8879253, 57.0827774, 52.5814191, 47.8801537, 43.1050719, 38.9808705,
      35.0527052, 31.0021163, 27.7220221, 24.4254631, 21.3648594, 18.4733999, 15.7553917, 12.8795826, 10.4799021,
      8.4241764, 6.766151, 5.4281237, 4.6843305, 4.1197137, 3.6211124, 3.1847327, 2.7739938, 2.4765833, 2.1894716,
      1.9336949, 1.6970658, 1.4700172,
    ],
    [crrem_type_of_use_enum.LODGING_LEISURE_RECREATION]: [
      51.586161, 47.6000496, 44.3333887, 41.1423897, 37.1088324, 34.2484137, 31.2614392, 28.061973, 25.4426584,
      22.9476156, 20.3063914, 18.2228533, 16.106561, 14.1624558, 12.3255696, 10.5986305, 8.664812, 7.1408667, 5.8348765,
      4.7808916, 3.9296829, 3.4549937, 3.0938615, 2.7745923, 2.4947819, 2.2312541, 2.0395632, 1.854434, 1.6891936,
      1.5361202, 1.3891521,
    ],
  },
  // CZ CRREM v2.05 (1.5°C all GHG) — extracted from Tylova_800_ostrov_nad_ohri_czechia_36301.xlsx, Back-end sheet (DATA-480)
  [country_enum.CZ]: {
    [crrem_type_of_use_enum.MFH]: [
      57.49737024, 53.21777801, 48.76480386, 44.51234132, 40.17149052, 36.48892044, 32.75636193, 29.22893361,
      26.06394398, 23.10698077, 20.20090449, 17.80726661, 15.47717889, 13.33257049, 11.34413785, 9.50932074,
      7.698942411, 6.137455325, 4.819750044, 3.770624139, 2.934988569, 2.468924304, 2.117484515, 1.811432841,
      1.547218978, 1.3027531, 1.126931355, 0.9601857111, 0.8138950476, 0.6807910033, 0.5552987644,
    ],
    [crrem_type_of_use_enum.OFFICE]: [
      119.8477356, 110.5698879, 102.6611776, 94.97644424, 85.53109802, 78.69240431, 71.59457574, 64.09978702, 57.916271,
      52.04887474, 45.88845342, 41.01719707, 36.09464406, 31.58107052, 27.32991666, 23.3451498, 18.907697, 15.40841356,
      12.41626285, 10.00628265, 8.063627364, 6.981408436, 6.159535524, 5.434414814, 4.800185052, 4.20399106,
      3.771377172, 3.354252479, 2.982636696, 2.638931434, 2.309336502,
    ],
    [crrem_type_of_use_enum.RETAIL]: [
      128.3907486, 118.6133722, 110.1050231, 101.8377124, 91.82976818, 84.47183208, 76.83496863, 68.84627786,
      62.19288526, 55.87971894, 49.28276003, 44.04147568, 38.75534496, 33.89893271, 29.32495204, 25.03767307,
      20.31349212, 16.54833809, 13.32900449, 10.73625487, 8.646480498, 7.482788899, 6.599300446, 5.819938511,
      5.138394667, 4.497780727, 4.033220637, 3.585323605, 3.186400034, 2.817508766, 2.463796658,
    ],
    [crrem_type_of_use_enum.SHOPPING_CENTER]: [
      98.41423639, 90.41732512, 84.04626319, 77.85542764, 69.8527463, 64.34554108, 58.6299547, 52.40167446, 47.42305863,
      42.69874645, 37.65773444, 33.73533752, 29.74510348, 26.11066806, 22.68733603, 19.47829821, 15.77609976,
      12.95858584, 10.54899812, 8.607691866, 7.042292696, 6.168993389, 5.505120642, 4.919090205, 4.406187514,
      3.923899182, 3.573204648, 3.234989181, 2.933398508, 2.65427749, 2.386526009,
    ],
    [crrem_type_of_use_enum.RETAIL_WAREHOUSE]: [
      84.70692687, 77.51769993, 72.11618997, 66.86731978, 59.77429931, 55.10665356, 50.262629, 44.83293563, 40.61406004,
      36.61051043, 32.27533307, 28.95123191, 25.54886419, 22.46876233, 19.56740677, 16.84749872, 13.60890906,
      11.2212795, 9.179022237, 7.53323462, 6.205711295, 5.464144595, 4.899897596, 4.401569425, 3.965168552, 3.55470253,
      3.255661593, 2.967201711, 2.709764815, 2.471366878, 2.242610294,
    ],
    [crrem_type_of_use_enum.HOTEL]: [
      116.6807414, 107.595167, 99.91726348, 92.45676983, 83.22797305, 76.58914077, 69.69879195, 62.39411092,
      56.39145496, 50.69563992, 44.70324615, 39.97441717, 35.19180875, 30.81019714, 26.68330246, 22.81497545,
      18.48788709, 15.09093983, 12.18623401, 9.846603533, 7.960575812, 6.909716506, 6.111560013, 5.407317276,
      4.791299165, 4.21220284, 3.791885357, 3.386605235, 3.025500485, 2.691489561, 2.371177563,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_COLD]: [
      65.57228793, 59.02728172, 54.57487367, 50.31164016, 44.22858712, 40.5306618, 36.77079987, 32.36953572,
      29.17150162, 26.1757709, 22.8720243, 20.43691986, 17.94437034, 15.75081957, 13.71101598, 11.82305318, 9.397209694,
      7.78432413, 6.418548649, 5.326747301, 4.45308131, 3.960772776, 3.586323559, 3.25812806, 2.972701147, 2.707147641,
      2.512777691, 2.327440631, 2.163136151, 2.012315094, 1.869164719,
    ],
    [crrem_type_of_use_enum.DISTRIBUTION_WAREHOUSE_WARM]: [
      30.84394865, 26.8435332, 25.26990291, 23.73999799, 20.23840171, 18.88541343, 17.48239454, 15.20559501,
      13.98624325, 12.82833011, 11.27985238, 10.31787754, 9.236459722, 8.34491736, 7.504372577, 6.715593539,
      5.307373715, 4.61696683, 4.024963764, 3.545910701, 3.157542927, 2.936068586, 2.765153138, 2.613081523,
      2.478716818, 2.35181183, 2.256704011, 2.164683723, 2.081569968, 2.003950477, 1.929149305,
    ],
    [crrem_type_of_use_enum.HEALTH_FACILITY]: [
      100.4662968, 92.35314711, 85.84255144, 79.51615229, 71.38255647, 65.75452546, 59.91350765, 53.57029823,
      48.48234386, 43.65430262, 38.51170993, 34.50320886, 30.42837163, 26.71415891, 23.21570627, 19.936275, 16.16735597,
      13.28797494, 10.8255226, 8.841686579, 7.242053342, 6.349795645, 5.671585189, 5.07293302, 4.549020515, 4.056395826,
      3.698267529, 3.352891452, 3.044946357, 2.759964649, 2.48660119,
    ],
    [crrem_type_of_use_enum.LODGING_LEISURE_RECREATION]: [
      90.66547549, 83.13124617, 77.31559208, 71.66436137, 64.18277925, 59.15651565, 53.94020345, 48.16939369,
      43.62599504, 39.31457169, 34.67789704, 31.09823384, 27.44475901, 24.12787356, 21.00355575, 18.07471591,
      14.63809575, 12.06684107, 9.867678598, 8.095660192, 6.666528196, 5.86869191, 5.261889772, 4.726099577,
      4.257020951, 3.815876027, 3.494771256, 3.185058275, 2.908761092, 2.652968291, 2.407555036,
    ],
  },
};
